export const environment = {
  production: false,
  baseUrl: 'https://staging-api.ekmatra.store/rest',
  adminUrl: 'http://128.199.17.123:3001/crm',
  AssetsUrl: 'http://128.199.17.123:3001/assets',
  encryptionKey: 'x90dh!2$bs',
//appName: "Ek Matra",
appName:'EKMATRA TECHNOLOGY PRIVATE LIMITED',
  appConfig: {
    currency: {
      code: 'INR',
      symbol: '₹'
    },
    defaultPageSize: 10
  },
  razorpay: {
    RAZORPAY_KEY_HERE: "rzp_test_ryxa3vd6r2KhDQ",
  }
};